import { RESET_ERROR_MESSAGE } from '../actionTypes';

export const resetError = (error) => {
  if (error) {
    return { type: null, error: error };
  }
  return { type: RESET_ERROR_MESSAGE };
};